import request from '@/util/request';

//获取顶级科室部门：（后端设计如此，获取顶级和非顶级用不同的接口）
export const getDeviceRightList = (params, options) =>
    request.get('/api/v4ward/device/permission/page', Object.assign({}, options, { params }));

//获取顶级科室部门：（后端设计如此，获取顶级和非顶级用不同的接口）
export const saveDeviceRight = (params, options) =>
    request.post('/api/v4ward/device/permission/save', params,options)

//获取顶级科室部门：（后端设计如此，获取顶级和非顶级用不同的接口）
export const removeDeviceRight = (params, options) =>
    request.post('/api/v4ward/device/permission/remove?id='+params.id, params,options)

//获取顶级科室部门：（后端设计如此，获取顶级和非顶级用不同的接口）
export const updateDeviceRight = (params, options) =>
request.post('/api/v4ward/device/permission/update', params,options)
    